<template>
 <div>
   <div v-if="commentWriting?.answer && commentWriting?.answer?.length > 0">
     <div>
       <span>Nhận xét:</span>
       <p>Học viên đọc phần nhận xét chi tiết để hiểu rõ những tiêu chí của kĩ năng này</p>
       <div style="display: flex; justify-content: center">
         <button @click="viewMore" style="padding: 5px 10px; display: flex; align-items: center; gap: 3px; color: #1da1f2">
           Xem thêm<i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
         </button>
       </div>
     </div>
     <div v-if="showMore">
       <div v-for="(comment, index) in commentWriting?.answer" :key="comment.key" style="display: flex; flex-direction: column; border-bottom: 1px solid lightgray; padding-bottom: 10px; margin-bottom: 10px">
         <label style="font-weight: 700; font-size: 14px">Tiêu chí {{index + 1}}: {{ getLabel(comment?.key) }}</label>
         <span style="word-break: break-word; white-space: pre-line">{{ comment?.comment_auto ?? "" }}</span>
         <span>Chi tiết :</span>
         <p style="word-break: break-word; white-space: pre-line">{{ comment?.comment }}</p>
       </div>
       <div v-if="commentWriting?.plagiarism?.type_of_plagiarism" style="display: flex; flex-direction: column      ">
         <span style="word-break: break-word; color: red; font-weight: 600; font-size: 13px; padding-bottom: 10px">Bài viết có dấu hiệu đạo văn !</span>
         <span style="word-break: break-word">Tỉ lệ đạo văn: {{ getValueCheating(commentWriting?.plagiarism?.type_of_plagiarism)?.label ?? '' }}</span>
         <span style="word-break: break-word">Phương án xử lý: {{ getValueCheating(commentWriting?.plagiarism?.type_of_plagiarism)?.problemSolution ?? '' }}</span>
         <span style="word-break: break-word">{{ commentWriting?.plagiarism?.description_of_plagiarism ?? '' }}</span>
       </div>
       <div v-else>
         <span style="font-weight: 600; font-size: 13px; padding-bottom: 10px">Bài viết không có dấu hiệu gian lận !</span>
       </div>
     </div>
   </div>
   <div v-else>
     <span>Chưa có nhận xét</span>
   </div>
 </div>
</template>

<script>
import { listCriteria, PLAGIARISM_RATE } from "@/core/option/testInputOption";

export default {
  name: 'CommentWriting',
  data() {
    return {
      showMore: false,
      PLAGIARISM_RATE,
      listCriteria
    }
  },
  props: {
    commentWriting: {
      type: Object,
      default: {},
    }
  },
  methods: {
    viewMore() {
      this.showMore = !this.showMore
    },
    getValueCheating(value) {
      if (!value) return null
      return this.PLAGIARISM_RATE.find(item => item.value === +value)
    },
    getLabel(key) {
      if (!key) return null
      return this.listCriteria[0][key] ?? ''
    }
  }
}
</script>

<style scoped>

</style>